import { PieChart, Pie, Cell } from 'recharts';
import styled from 'styled-components';

const COLORS = ['#008AFF', '#F45551'];

type GraphCircleProps = {
  totalCnt: number;
  winCnt: number;
};

const GraphCircle = ({ totalCnt, winCnt }: GraphCircleProps) => {
  const loseCnt = totalCnt - winCnt; // 전체 - 수익 = 손실

  const data = [
    { name: '수익물건', value: winCnt },
    { name: '손실물건', value: loseCnt },
  ];
  return (
    <GraphWrap>
      <GraphBox>
        <PieChart width={160} height={160}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            dataKey="value"
            startAngle={90}
            endAngle={-270}
            stroke="none"
            paddingAngle={5}
          >
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
        </PieChart>
        <CenterText>
          <div>전체물건</div>
          <span>{totalCnt.toLocaleString()}</span>
        </CenterText>
      </GraphBox>

      <Amount>
        <div>
          <Bar />
          <Label>수익물건</Label>
          <Label02>{winCnt.toLocaleString()}</Label02>
        </div>
        <div>
          <Bar02 />
          <Label>손실물건</Label>
          <Label02>{loseCnt.toLocaleString()}</Label02>
        </div>
      </Amount>
    </GraphWrap>
  );
};

export default GraphCircle;

const GraphBox = styled.div`
  width: 160px;
  height: 160px;
  position: relative;
  display: flex;
  align-items: center;
`;
const Amount = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;

  > div {
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: row;
    gap: 4px;
    line-height: 20px;
  }
`;
const GraphWrap = styled.div`
  display: flex;
  padding: 16px 0;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const Bar = styled.div`
  width: 16px;
  height: 16px;
  background: #008aff;
  border-radius: 4px;
`;
const Bar02 = styled.div`
  width: 16px;
  height: 16px;
  background: #f45551;
  border-radius: 4px;
`;
const Label = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.28px;
  color: #616161;
`;
const Label02 = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.28px;
  color: #222222;
`;
const CenterText = styled.div`
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #616161;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
  span {
    color: #222;
    font-size: 16px;
    font-weight: 500;
    line-height: 145%; /* 23.2px */
    letter-spacing: -0.32px;
    text-align: center;
  }
`;
